<template>
    <div v-if="c_data">
    <div v-if="c_data.environment">
        <div v-if="show_info">
            <RowComponent
                label="condizioni ambientali"
                :value="`temperatura: `+c_data.environment.temperature+`°C, umidità: `+c_data.environment.humidity+`UHR`"
            >
            </RowComponent>
        </div>
        <BasicCard v-else>
            <template v-slot:title>
                <div class="d-flex flex-grow-1" @click="c_expand=!c_expand">
                    <StatusIcon class="px-2" :status="statusIcon" :key="c_data.environment.temperature+'_'+c_data.environment.humidity"/>
                    Condizioni ambientali
                </div>
            </template>
            <template v-slot:action>
                <span @click="c_expand=!c_expand">
                    <v-icon v-if="c_expand">expand_less</v-icon>
                    <v-icon v-else>expand_more</v-icon>
                </span>
            </template>
            <div v-if="c_expand">
                <v-form v-model="valid.object" class="d-flex flex-grow-1 ">
                    <div class="d-flex ma-2">
                        <NumericField dense outlined
                            @input="updateStatusIcon"
                            label="temperatura"
                            v-model="c_data.environment.temperature"
                            suffix="°C"
                            class="pr-2"
                            negative
                            />
                        <NumericField dense outlined
                            @input="updateStatusIcon"
                            label="umidità"
                            v-model="c_data.environment.humidity"
                            suffix="UHR"
                            />
                    </div>
                </v-form>
            </div>
        </BasicCard>
    </div>
    <div v-else>
        <span class="subtitle-1">Errore nel caricamento dei dati specifici per il report.</span>
    </div>
    </div>
</template>
<script>
import RowComponent from '../../../components/utils/RowComponent'
import StatusIcon from '../../../components/utils/StatusIcon'
import BasicCard from '../../../components/utils/Basic_card'
import {CustomDataMixin} from "../../../utils/CustomDataMixin.js"
import {getModel} from '../../../utils/model'
// import _ from 'lodash'

export default {
    mixins: [CustomDataMixin],
    components: {BasicCard, RowComponent, StatusIcon},
    data() {
        return {
            valid: {
                object: false,
                metro: false
            },
            c_expand: 1,
            statusIcon: 'ko'
        }
    },
    mounted() {
        let model = null
        model = getModel('IsoCustomData')
        if (model) {
            this.c_data = model(this.o_data)
        } else {
            this.c_data = _.cloneDeep(this.o_data)
        }
        this.updateStatusIcon()
    },
    methods: {
        updateStatusIcon() {
            console.log("AMB", this.c_data.environment.humidity, this.c_data.environment.temperature)
            this.statusIcon = (this.c_data.environment.humidity != null && this.c_data.environment.humidity!= '' ) && (this.c_data.environment.temperature!=null && this.c_data.environment.temperature != '' ) ? 'ok' : 'ko'
        }
    }
}
</script>
